<div class="sidebar-candidate container-fluid p-4"><app-loading [isLoading]="isLoading">
  <div class="row">
    <div class="col-12 col-md-10">
      <tabset type="pills">
        @for (t of tabs; track trackByFn(t); let i = $index) {
          <tab [active]="t.isActive" (selectTab)="selectTab(i)"><ng-template tabHeading="tabHeading"><span class="lnr" [ngClass]="t.icon" [tooltip]="t.label | translate" container="body"></span></ng-template></tab>
        }
      </tabset>
    </div>
    <div class="col-12 col-md-2"><button class="btn-close d-block ms-auto me-0" type="button" (click)="close()"></button></div>
  </div>
  @if (candidate) {
    <div class="row mt-4">
      <div class="col-12">@if (activeTab === 0) {
        <app-sidebar-candidate-details [candidate]="candidate"></app-sidebar-candidate-details>
        }@if (activeTab === 1) {
        <app-sidebar-candidate-activities [candidate]="candidate"></app-sidebar-candidate-activities>
        }@if (activeTab === 2) {
        <app-sidebar-candidate-comments [candidate]="candidate"></app-sidebar-candidate-comments>
        }@if (activeTab === 3) {
        <app-sidebar-candidate-emails [candidate]="candidate"></app-sidebar-candidate-emails>
        }@if (activeTab === 4) {
        <app-sidebar-candidate-texts [candidate]="candidate"></app-sidebar-candidate-texts>
        }@if (activeTab === 5) {
        <app-sidebar-candidate-reference-requests [candidate]="candidate"></app-sidebar-candidate-reference-requests>
        }@if (activeTab === 6) {
        <app-sidebar-candidate-reminders [candidate]="candidate"></app-sidebar-candidate-reminders>
        }@if (activeTab === 7) {
        <app-sidebar-candidate-about [candidate]="candidate"></app-sidebar-candidate-about>
      }</div>
    </div>
  }
</app-loading></div>
